module.exports = __webpack_public_path__ + "img/9.0a987776.jpg";